import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IMatchListGroupStatsPayloadState } from '@app-store/slices/companyStatistics/matchListGroupStats'

interface TaskAction extends Action {
    payload: IMatchListGroupStatsPayloadState
}

const { onRequest, onSuccess, onFailure } = rootActions.companyStatistics.matchListGroupStats

function* matchListGroupStatsSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/companies/stats/match-list-group/all`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload?.sagaCB && payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
        yield payload?.sagaCB && payload.sagaCB?.onError()
    }
}

function* matchListGroupStatsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, matchListGroupStatsSagaTask)
}

export default matchListGroupStatsSaga
